<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <form #fr="ngForm" [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
        <div class="grid form-group">
          <div class="col-12 md:col-2 lg:col-4">
            <div class="div-form">
              <label>{{'HOMOLOGACIONPLANESCARGOS.LBL_PLANPRODUCTO' | translate}}:</label>
              <p-dropdown disableTab  id="idPlanCargoProducto" name="nomIdPlanCargoProducto" [options]="lisPlanesCargos"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="planCargoProducto"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.planCargoProducto.invalid">
                {{ 'HOMOLOGACIONPLANESCARGOS.LBL_PLANPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-2 lg:col-4">
            <div class="div-form">
              <label>{{'HOMOLOGACIONPLANESCARGOS.LBL_COMODINFONDOSGARANTIAS' | translate}}:</label>
              <p-dropdown disableTab  id="idComodinPlanCargo" name="idComodinPlanCargo" [options]="lisPlanCargoComodin"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                           formControlName="idComodinPlanCargo"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idComodinPlanCargo.invalid">
                {{ 'HOMOLOGACIONPLANESCARGOS.LBL_COMODINFONDOSGARANTIAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-2 lg:col-4">
            <div class="div-form">
              <label>{{ 'HOMOLOGACIONPLANESCARGOS.LBL_CODIGOSHIVAM' | translate }}</label>
              <input [maxLength]="4" pInputText appTexto formControlName="codigoShivam"
                     name="nomCodigoShivam" id="idCodigoShivam" required="true" type="text">
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoShivam.invalid">
                {{ 'HOMOLOGACIONPLANESCARGOS.LBL_CODIGOSHIVAM' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guardando">
              <a (click)="cancelar((fr.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit" pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
      <p-confirmDialog #cd>
        <p-footer>
          <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate}}" (click)="cd.reject()"></button>
          <button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate}}" (click)="cd.accept()"></button>
        </p-footer>
      </p-confirmDialog>
    </div>
  </div>
</div>
